<h5 mat-dialog-title>{{'front.modale.reouvertureDossier.titre' | translate}} {{data.dossier.numeroDossier}}</h5>

<!-- CONTENT -->
<mat-dialog-content>
  <div class="row pt-1">
    <div class="col-3 font-weight-bold">{{'general.titre' | translate}} :</div>
    <div class="col-9">{{getTitreTranslation()}}</div>
  </div>
  <div class="row">
    <div class="col-3 font-weight-bold">{{'general.candidat' | translate}} :</div>
    <div class="col-9">
      <i [ngClass]="data.dossier.candidat.locale==='fr' ? 'flag-icon flag-icon-fr' : 'flag-icon flag-icon-gb'"></i>
      {{data.dossier.candidat.nom | uppercase}} {{data.dossier.candidat.prenom}}
      @if (data.dossier.candidat.locale!=='fr') {
        <span class="alert alert-danger bloc-trad-comm ml-1">
          {{'front.modale.reouvertureDossier.traduireCommentaire' | translate}}
        </span>
      }
    </div>
  </div>
  <div class="row">
    <div class="col-3 font-weight-bold">{{'general.aide' | translate}} :</div>
    <div class="col-9">{{data.dossier.aide.label}}</div>
  </div>
  <div class="row">
    <div class="col-3 font-weight-bold">{{'general.statutDossier' | translate}} :</div>
    <div class="col-9">{{ data.dossier.statutLibelle|translate }}</div>
  </div>

  <p class="pt-2">{{'front.modale.reouvertureDossier.texteCommentaire' | translate}}</p>
  <quill-editor
    id="Commentaire"
    class="form-control form-control-1"
    [modules]="modules"
    name="editor"
    [(ngModel)]="text"
    [placeholder]="' '"
    [styles]="{'height': '200px'}"
  ></quill-editor>
  <div id="reouverture-comment-counter" class="quill-counter">0 {{modules['counter'].unit}}</div>

</mat-dialog-content>

<!-- ACTIONS -->
<mat-dialog-actions>
  <button mat-button type="button" [mat-dialog-close]="null">Annuler</button>
  <button mat-raised-button color="primary" type="submit" [disabled]='text.trim().length === 0' [mat-dialog-close]="text">{{'front.modale.reouvertureDossier.btnRouvrir' | translate}}</button>

</mat-dialog-actions>
